import Disciplinary from './Disciplinary';

export default Disciplinary;
